var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DateTime } from 'luxon';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';
import { FormControl, FormLabel, TimePicker } from 'shared/components';
var startTimeIntervalMinutes = 15;
var startTimeIntervalsToDisplay = 24 * (60 / startTimeIntervalMinutes);
export var EndTime = function () {
    var register = useFormContext().register;
    var errors = useFormState().errors;
    var startAt = DateTime.local().startOf('day');
    var startTimeVal = useWatch({ name: 'interactionStartTime' });
    return (_jsxs(FormControl, __assign({ mr: 2, width: "auto", isRequired: true }, { children: [_jsx(FormLabel, __assign({ htmlFor: "interactionEndTime" }, { children: "End time" })), _jsx(TimePicker, { "data-testid": "interactionEndTime", name: "interactionEndTime", fromDate: startAt, format: "h:mm a ZZZZ", placeholder: "Select time", intervalMinutes: startTimeIntervalMinutes, numIntervals: startTimeIntervalsToDisplay, register: register, rules: {
                    required: 'You must select an end time',
                    validate: function (endTimeVal) { return endTimeVal > startTimeVal || 'Invalid end time'; },
                }, displayErrors: true, errors: errors })] })));
};
